var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12" } },
    [
      _c("w-checkbox", {
        attrs: {
          value: _vm.openInNewTab,
          label: _vm.$ct("open-image-in-new-tab"),
        },
        on: {
          input: function ($event) {
            return _vm.setOpenInNewTab($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }